
import React from 'react';
import {
    Button as RaButton
} from 'react-admin';
import {
    makeStyles, Button, Dialog, DialogContent, DialogActions, CircularProgress,
} from '@material-ui/core';
import notify from './CustomUseNotify';
import DeleteIcon from '@material-ui/icons/Delete';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { translate, crudDelete } from 'ra-core';
import config from "../config.json";
import { customTheme } from "../customTheme";

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    loaderContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        width: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    columnButton: {
        color: customTheme.palette.primary.main,
        WebkitTouchCallout: "none",
        WebkitUserSelect: "none",
        KhtmlUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none",
        '&:hover': {
            cursor: 'pointer',
        },
        "&:active": {
            opacity: 0.6,
        }
    },
    menuLink: {
        textDecoration: "none",
        color: "#444",
    },
    columnLink: {
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
        }
    },
});

function CustomDeleteButtonDashboardPath(props) {
    const { record, resourcePath, refresh, disabled = false } = props;
    const classes = useStyles();

    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [deleting, setDeleting] = React.useState(false);


    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const handleDelete = (event) => {
        event.preventDefault();
        setDeleting(true);
        fetch(`${config.HOST_NAME}/dashboard/${resourcePath}/${record.id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            },
        })
            .then(response => response.json())
            .then((responseJson) => {
                setDeleting(false);
                if (responseJson.success) {
                    refresh();
                    notify("Successfully Deleted", "success");
                    setDialogVisible(false);
                }
                else {
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                setDeleting(false);
                notify('Error While Deleting Record', 'warning')
            });
    };

    return (
        <>
            <RaButton onClick={openDialog} style={{ color: disabled ? "#BDBDBD" : "#de575e" }} label={false} className={classes.deleteButton} disabled={disabled}>
                <DeleteIcon />
            </RaButton>
            <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
                <DialogContent>
                    <p>Are you sure you want to <strong>Delete</strong> this Record.</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog} color="default">Cancel</Button>
                    <Button onClick={handleDelete} className={classes.deleteButton}>Delete {deleting && <CircularProgress size={20} />}</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
export default CustomDeleteButtonDashboardPath